<template>
  <div class="md-layout" >
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <div class="md-layout-item" >
      <ElasticList :list="list" :filter="filter" :exclude="exclude"></ElasticList>
    </div>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";

  export default {
    components: {
      ElasticList
    },
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "casetemplates",
          pageTitle: "Case Templates",
          pageIcon: "list_alt",
          linkRows: true,
          listQueryId: "customSearchCaseTemplates",
          responseFieldName: "searchCaseTemplates",
          deleteQueryId: "deleteCaseTemplate",
          deleteMessageNameFields: ['subject'],
          disassociateRelatedRecord: {
            record: [
              { updateQueryId: "updateTask", updateFieldId: "taskCaseTemplateId", relatedModelItem: 'tasks' }
            ]
          },
          columns: {
            subject: { label: "Subject", sortable: true },
            status: { label: "Status", sortable: true, optionType: "enum" },            
            priority: { label: "Priority", sortable: true, optionType: "enum" },
            createdAt: { label: "Created", sortable: true }
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
        },
        exclude: {},
        filter: [],
      };
    },
    beforeMount() {
      this.generateFilters();
    },
    methods: {
      generateFilters() {
        if (this.$Session.isInternalGroupMember) {
          this.filter = [];
          this.exclude = {};
          return;
        }
        this.filter = [ 
          { term: { internal: false } }
        ];
        this.exclude = {
          must_not: [
            { term: { internal: true } },
          ]
        };
      }
    },
    watch: {
      '$Session.isInternalGroupMember': {
        immediate: true,
        handler: function() {
          this.generateFilters();
        },
      },
    }
  };
</script>

<style></style>
